module.exports = __webpack_public_path__ + "static/media/dermalogica-logo-dark.6f98321a.svg";